import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import {
  getAllowedPageSizes,
  type AllowedPageSizesResponse,
} from "@/services/api/configuration";

const allowedPageSizesKeys = {
  all: ["allowedPageSizes"] as const,
  list: () => [...allowedPageSizesKeys.all] as const,
};

export function useAllowedPageSizes(
  options?: Omit<
    UseQueryOptions<AllowedPageSizesResponse, Error>,
    "queryKey" | "queryFn"
  >
) {
  return useQuery<AllowedPageSizesResponse, Error>({
    queryKey: allowedPageSizesKeys.list(),
    queryFn: getAllowedPageSizes,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours (1 day)
    gcTime: 7 * 24 * 60 * 60 * 1000, // 7 days (keep in cache for a week)
    ...options,
  });
}
